import { Component, Input } from '@angular/core';

interface ImageFile {
    uploadId?: string;
    fileId?: string;
    filename: string;
    type: string;
    url?: string;
}

interface ImageData {
    files: ImageFile[];
}

export interface InstructionData {
    PAGE: string;
    URL: string;
    IMAGE: ImageData;
}

@Component({
    selector: 'vb-bidding-instruction-display',
    templateUrl: './bidding-instruction-display.component.html',
    styleUrls: ['./bidding-instruction-display.component.scss'],
})
export class BiddingInstructionDisplayComponent {
    @Input() instruction?: InstructionData;

    getImageUrl(): string {
        return this.instruction?.IMAGE?.files?.[0]?.url || '';
    }
}
